<template>
  <div v-if="text" :id="id" class="alert" :class="type" aria-live="assertive" v-html="text" />
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'danger',
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:color'; //already imported via vite.config.mjs but also here to keep IDE happy

@mixin alert-variant($color) {
  color: $color;
  background: color.adjust($color, $lightness: 35%);
  border-color: color.adjust($color, $lightness: 10%);
}

.alert {
  margin: 0.25em 0 0;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;

  :deep(li) {
    margin-left: 2em;
  }
}

.success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
}
.info {
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb;
}
.warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}
.danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
</style>
